"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import NetworkServicesTabs from "@/components/pageTabs/networkServicesTabs";
import ComparisonComp from "./components/comparison";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import AdvantageComp from "./components/advantages";
import ServiceByOneMind from "./components/serviceByOneMind";
import ColocationPricing from "../pricing/components/tables/colocation";
import Solutions from "./components/solutions";

const ColocationPage = () => {
  return (
    <Box>
      <Hero />
      <PageLayout>
        <NetworkServicesTabs />
        <Box>
          <Intro />
          <AdvantageComp />
        </Box>
        <ServiceByOneMind />
        <ColocationPricing />
      </PageLayout>
      <ComparisonComp />
      <PageLayout showContactForm>
        <Solutions />
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default ColocationPage;
